import { useLocation } from 'react-router-dom';

/**
 * Bug de rota: Gestor SME caía em `/operacao/financeiro/...` ao abrir uma
 * competência, mesmo entrando pelo menu de SME (`/sme/fechamento-mensal`).
 * Já era um bug conhecido e corrigido no protótipo (`useFechamentoBasePath.ts`,
 * comentário "1.6 — Bug de rota").
 *
 * Devolve o prefixo correto pros links internos do Fechamento Mensal v2,
 * conforme o casco em que a tela está embarcada:
 *   - dentro de `/sme/...`  → `/sme`
 *   - qualquer outro caso   → `/operacao/financeiro`
 */
export function useFechamentoBasePath(): '/sme' | '/operacao/financeiro' {
  const { pathname } = useLocation();
  return pathname === '/sme' || pathname.startsWith('/sme/') ? '/sme' : '/operacao/financeiro';
}
